import { useContext } from 'react'

import { QuizContentSubtype } from 'globalTypes'

import { Context as UsageContext } from 'Root/App/Contexts/Usage'

import { Context as StateContext } from '../StateContext'
import { isCompleted } from '../utilities'
import Completion from './Completion'
import Cover from './Cover'
import Questions from './Questions'

const Usage = ({ setIsCompleted }) => {
  const { state, dispatch } = useContext(StateContext)
  const useCase = useContext(UsageContext)

  // formik contains local status
  // while state contains already submitted answers
  if (
    isCompleted(state) ||
    (state.content.separateEvaluation && Object.keys(state.points).length !== 0)
  ) {
    setIsCompleted?.(true)
    return <Completion content={state.content} />
  }

  if (
    !state.startedAt ||
    (useCase === 'card' &&
      state.content.quizSubtype !== QuizContentSubtype.quick_quiz)
  ) {
    const start = () => dispatch({ type: 'start' })
    return <Cover content={state.content} startCallback={start} />
  }
  return <Questions />
}

export default Usage
